import EntryContainer from "./EntryContainer/EntryContainer"
import ContactsContainer from "./ContactsContainer/ContactsContainer"

export default function PageContainer({...params}){
    let pageMode = params.pageMode

    let stationAttributes = params.stationAttributes
    let contactsList = params.contactsList

    let stateObject = params.stateObject
    let setStateObjectEntryHelper = params.setStateObjectEntryHelper
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper

    return (
        <>
            <EntryContainer pageMode={pageMode} stationAttributes={stationAttributes} stateObject={stateObject} setStateObjectEntryHelper={setStateObjectEntryHelper}
                                setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper} />
            <ContactsContainer contactsList={contactsList}></ContactsContainer>
        </>
    )
}
